<template>
  <page>
    <div>
      <!-- Add Filters here -->
      <v-flex xs12>
        <form action="">
          <v-expansion-panels>
            <v-expansion-panels>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-card>
                    <v-card-text>
                      <v-container fluid grid-list-lg>
                        <v-layout row wrap>
                          <v-flex md6>
                            <v-text-field
                              v-model="filter.propStat"
                              :label="label.propStat"
                              data-vv-name="propStat"
                              :data-vv-as="label.propStat"
                              :error-messages="errors.collect('propStat')"
                            ></v-text-field>
                          </v-flex>
                          <v-flex md6>
                            <v-text-field
                              v-model="filter.propStatDesc"
                              :label="label.propStatDesc"
                              data-vv-name="propStatDesc"
                              :data-vv-as="label.propStatDesc"
                              :error-messages="errors.collect('propStatDesc')"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                      <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-expansion-panels>
        </form>
      </v-flex>
      <v-spacer class="mt-1"></v-spacer>
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn color="primary" dark class=" mr-2" @click="doNew">
            New Proposal Status
            <v-icon right>mdi-plus</v-icon>
          </v-btn>
          <v-flex xs12>
            <message :messages="messages"></message>
          </v-flex>
        </v-card-title>
        <v-flex xs12>
          <v-card>
            <v-data-table
              :headers="headers"
              :items="items"
              :loading="loading"
              :footer-props="{'items-per-page-options': itemsPerPage }"
              v-bind:options.sync="pagination"
              :server-items-length="totalItems"
              :no-data-text="noDataText"
            >
              <template v-slot:item="row"
                ><tr>
                  <td class="text-xs-left">{{ row.item.propStat }}</td>
                  <td class="text-xs-left">{{ row.item.propStatDesc }}</td>
                  <td class="text-xs-left">{{ formatBoolean(row.item.perRev) }}</td>
                  <td class="text-xs-left">{{ formatBoolean(row.item.allowCnvPol) }}</td>
                  <td class="table-action-header">
                    <table-action
                      :rowData="row"
                      review
                      @review="doReview(row.item)"
                      query
                      @query="doQuery(row.item)"
                      remove
                      @remove="doPromptRemove(row.item)"
                    ></table-action>
                  </td></tr
              ></template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-card>
      <confirm v-model="promptRemove" @ok="doDelete">
        <p>Are you sure you want to delete the selected Proposal Status?</p>
        <div class="queryValue">
          Proposal Status: {{ selected.propStat }}<br />
          Description: {{ selected.propStatDesc }}
        </div>
      </confirm>
    </div>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI, filterQuery } from '@/utils/ajax'

export default {
  data() {
    return {
      toogleArray: [false],
      loading: false,
      headers: [
        { text: 'Proposal Status', value: 'propStat' },
        { text: 'Description', value: 'propStatDesc' },
        { text: 'Permit on Review', value: 'perRev' },
        { text: 'Allow Convert to Policy', value: 'allowCnvPol' },
        TableConst.tableActionHeader
      ],
      label: {
        propStat: 'Proposal Status',
        propStatDesc: 'Description'
      },
      filter: {
        propStat: undefined,
        propStatDesc: undefined
      },
      totalItems: 0,
      promptRemove: false,
      selected: {
        propStat: null,
        propStatDesc: null,
        perRev: null,
        allowCnvPol: null
      },
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  async mounted() {
    this.fetchData(true)
    this.doInit()
  },
  watch: {
    'pagination': function (value) {
      this.fetchData(false)
    }
  },
  methods: {
    async doInit() {
      this.fetchData(true)
    },
    async fetchData(options) {
      this.resetMessages()
      const apiURI = this.menu.getPropStatList
      if (apiURI) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          const result = await this.$http.get(filterQuery(expandURI(apiURI, expand), this.filter, this.pagination.sortBy, this.pagination.sortDesc))
          if (result) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            this.items = []
            if (data) {
              data.map((datamap) => {
                const convertList = {
                  propStat: datamap.propStat,
                  propStatDesc: datamap.propStatDesc,
                  perRev: datamap.perRev,
                  allowCnvPol: datamap.allowCnvPol
                }
                this.items.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      }
    },
    doNew() {
      const commit = {
        tranMode: 'New',
        propStat: null,
        propStatDesc: null,
        perRev: null,
        allowCnvPol: null
      }
      sessionStorage.setItem('propStat', JSON.stringify(commit))
      this.$store.commit('PROPSTAT_COMMIT_KEY', commit)
      this.$router.push({ name: 'propStatReview' })
    },
    doQuery(data) {
      const commit = {
        tranMode: 'Query',
        propStat: data.propStat,
        propStatDesc: data.propStatDesc,
        perRev: data.perRev,
        allowCnvPol: data.allowCnvPol
      }
      sessionStorage.setItem('propStat', JSON.stringify(commit))
      this.$store.commit('PROPSTAT_COMMIT_KEY', commit)
      this.$router.push({ name: 'propStatReview' })
    },
    doReview(data) {
      const commit = {
        tranMode: 'Review',
        propStat: data.propStat,
        propStatDesc: data.propStatDesc,
        perRev: data.perRev,
        allowCnvPol: data.allowCnvPol
      }
      sessionStorage.setItem('propStat', JSON.stringify(commit))
      this.$store.commit('PROPSTAT_COMMIT_KEY', commit)
      this.$router.push({ name: 'propStatReview' })
    },
    doPromptRemove(data) {
      if (data) {
        this.selected.propStat = data.propStat
        this.selected.propStatDesc = data.propStatDesc
        this.selected.perRev = data.perRev
        this.selected.allowCnvPol = data.allowCnvPol
        this.promptRemove = true
      }
    },
    doDelete() {
      this.resetMessages()
      if (this.selected && this.selected.propStat) {
        const apiURI = this.menu.deletePropStat
        if (apiURI) {
          const expand = {
            propStat: this.selected.propStat,
            propStatDesc: this.selected.propStatDesc,
            perRev: this.selected.perRev,
            allowCnvPol: this.selected.allowCnvPol
          }
          this.$http
            .post(apiURI, expand)
            .then((result) => {
              const data = result.data
              this.notify(data)
              this.promptRemove = false
              this.fetchData(false)
            })
            .catch((err) => {
              this.promptRemove = false
              const { data } = err.response
              if (data) {
                this.message(data)
              }
            })
        }
      }
    },
    doClearFilters() {
      this.resetMessages()
      this.filter.propStat = undefined
      this.filter.propStatDesc = undefined
      this.fetchData(false)
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.fetchData(false)
        } else {
          this.promptFieldCheck()
        }
      })
    },
    formatBoolean(value) {
      if (value) {
        return 'Yes'
      }
      return 'No'
    }
  },
  computed: {
    menu() {
      return this.$store.state.propStatParam.menu
    }
  },
  mixins: [TableConst.default, MessageMixin]
}
</script>
